import { Attributes } from '@leverege/ui-attributes';
export default {
  type: 'condition.Attribute',
  convert: (value, context) => {
    const {
      attrName
    } = value;
    const {
      objectType,
      comparatorConverterFactory
    } = context;
    const attribute = Attributes.getAttribute(attrName, objectType);
    if (!value?.comparator || !attribute) {
      return null;
    }
    return comparatorConverterFactory.create(value.comparator, attribute, context);
  }
};